import { render, staticRenderFns } from "./AgentNewsWidget.vue?vue&type=template&id=fe09f402&scoped=true&"
import script from "./AgentNewsWidget.vue?vue&type=script&lang=js&"
export * from "./AgentNewsWidget.vue?vue&type=script&lang=js&"
import style0 from "./AgentNewsWidget.vue?vue&type=style&index=0&id=fe09f402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe09f402",
  null
  
)

export default component.exports